* {
  box-sizing: border-box;
}

:host {
  height: 100%;
  display: block;
  overflow: auto;
  position: relative;
}
